<template>
	<div id="qe_right2">
		<div class="cc-header">体质健康</div>
		<div class="main-value" id="school_health"></div>
	</div>
</template>

<script>
	var storage = window.localStorage;
	var orgCode = storage.getItem("orgCode");
	const echarts = require("echarts");
	export default {
		data() {
			return {
			};
		},
		mounted() {
			this.initData();
			// 定时器刷新，1小时
			let _this = this;
			setInterval(() => {
				_this.initData();
			}, 1000 * 60 * 60);
		},
		methods: {
			initData() {
				let _this = this;
				// 基于准备好的dom，初始化echarts实例
				let sportChart = echarts.init(document.getElementById("school_health"));
				this.$http.get("/dataView/quality/edu/getSportResult?orgCode=" + orgCode + "&termName=" + _this.$parent.$parent.$parent.termName).then(res => {
					if (res.data.code === 200) {
						var result = res.data.result;
						var option = {
							tooltip: {
								trigger: 'item',
								formatter: function(params) {
									var relVal = '体测成绩<br/>' + params.marker + '&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params.value + '</b>人';
									return relVal
								}
							},
							legend: {
								bottom: '10',
								textStyle: {
									fontSize: fontSize(0.15),
									height: 13,
									rich: {
										a: {
											verticalAlign: 'middle'
										}
									},
									color: '#54beff' // 把颜色这里做成函数就可以了
								},
								itemWidth: 20,
								itemHeight: 10
							},
							series: [{
								name: '体质健康',
								type: 'pie',
								radius: '60%',
								data: [{
										value: result.yx,
										name: '优秀',
										itemStyle: {
											color: '#ff8789'
										}
									},
									{
										value: result.lh,
										name: '良好',
										itemStyle: {
											color: '#7e4bff'
										}
									},
									{
										value: result.jg,
										name: '及格',
										itemStyle: {
											color: '#bc81ff'
										}
									},
									{
										value: result.bjg,
										name: '不及格',
										itemStyle: {
											color: '#55aaff'
										}
									}
								],
								// labelLine: {
								// 	normal: {
								// 		smooth: 0.2,
								// 		length: 15,
								// 		length2: 10
								// 	}
								// },
								label: {
									normal: {
										padding: [0, 0], //文字和图的边距
										textStyle: {
											color: '#54beff',
											lineHeight: 18,
											fontSize: fontSize(0.15)
										},
										formatter: ' {b} \n {c}人 '
									}
								}
							}]
						};
						sportChart.setOption(option);
						// 响应式变化
						window.addEventListener("resize", () => sportChart.resize(), false);
					}
				})

			}
		},
		destroyed() {
			window.onresize = null;
		}
	};

	function fontSize(res) {
		let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		if (!clientWidth) return;
		let fontSize = 100 * (clientWidth / 1920);
		return res * fontSize;
	}
</script>

<style lang="scss">
	#qe_right2 {
		height: 100%;
		padding: 0 2%;

		.cc-header {
			width: 100%;
			padding-top: 0.25rem;
			color: #55ffff;
			font-size: 0.25rem;
			text-align: center;
			height: 10%;
		}

		.main-value {
			height: 88%;
		}
	}
</style>